import * as helpers from './helpers';

export default function sidebar() {
    var mobile_toggle = $('.filterable-wrapper .mobile-sidebar-toggle');
    var sidebar = $('.filterable-wrapper .sidebar');

    mobile_toggle.on('click', function(e) {
        sidebar.toggleClass('sidebar-active');
    });

    $(window).on('resize', function() {
        var breakpoint = helpers.breakpoint()
        if (breakpoint && breakpoint != 'mobile-landscape') {
            sidebar.removeClass('sidebar-active');
        }
    });
};
